<template>
<div>
  <div class="title-bar title-h3">{{title}} 이벤트/알람 설정</div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <el-select class="mr-r10" v-show="isMultiKeyManagetype(managetypeId)" v-model="managetypeKey" style="width:120px;margin-rignt:4px">
        <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.managetypeKeyName" :value="item.managetypeKey"></el-option>
      </el-select>
      <!-- 0412 el-select width 수정 -->
      <span class="mr-r4">자원 구분 </span>
      <el-select class="mr-r10" v-model="rsctypeId" style="width:130px">
        <el-option v-for="item in rsctypeList" :key="item.rsctypeId" :label="item.rsctypeName" :value="item.rsctypeId"></el-option>
      </el-select>
      <span class="mr-r4">자원 </span>
      <el-select class="mr-r10" v-model="rsctypeRscKey" style="width:130px;">
        <el-option v-for="item in rscList" :key="`${item.rsctypeId}.${item.rscId}`" :label="item.rscName" :value="`${item.rsctypeId}.${item.rscId}`"></el-option>
      </el-select>
      <div class="vertical-center-box mr-l4">
        <span class="mr-r5">적용여부</span>
        <div class="setting-addel">
          <!-- add 1210 height ie friendly -->
          <el-button size="mini" style="height:27px" @click="onCollectAll(true)"><i class="fas fa-check-square"></i></el-button>
          <el-button size="mini" style="height:27px" @click="onCollectAll(false)"><i class="far fa-square"></i></el-button>
        </div>
      </div>
    </div>
    <div class="vertical-center-box">
      <el-button class="mr-r4" size="mini" type="primary" @click="clickSaveButton" :disabled="!rsctypeDataChangeFlag">저장</el-button>
      <el-button class="mr-r4" size="mini" @click="clickCancelButton" :disabled="!rsctypeDataChangeFlag">취소</el-button>
      <el-button class="mr-r4" size="mini" @click="exportExcel">
        <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
        <span style="left:2px;bottom:5px;">  엑셀출력</span>
      </el-button>
      <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper v-loading="loading" :element-loading-text="loadingText" :data="eventAlarmRuleTableData" :columns="eventAlarmRuleTableColumn" ref="eventAlarmRuleTable" highlight-current-row @row-dblclick="dblclickRow" remote :total="total" :pagination="true"
    @condition-change="loadData" style="width:100%;" :show-search-tool="showSearchTool" :show-custom-header="true" row-class-name="c-dblclick">
    <template #apply-slot="scope">
        <el-switch v-if="scope.row.eventlevelId !== 'NM'" v-model="scope.row.applyFlag" active-value="Y" inactive-value="N" @change="changeApplyFlag(scope.row)" :disabled="scope.row.eventlevelId === 'NM'"></el-switch>
      </template>
    <template #eventlevel-slot="scope">
        <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
      </template>
    <template #sms-slot="scope">
        <el-switch v-model="scope.row.smsFlag" active-value="Y" inactive-value="N" @change="chackTableDataChangeFlag"></el-switch>
      </template>
    <template #email-slot="scope">
        <el-switch v-model="scope.row.emailFlag" active-value="Y" inactive-value="N" @change="chackTableDataChangeFlag"></el-switch>
      </template>
  </el-table-wrapper>
  <w-update-event-alarm-rule-popup sliding-popup-type="setting" ref="updateEventAlarmRulePopup" :target-event-alarm-data="updateRow" @reload="loadData" :has-auth="hasAuth"></w-update-event-alarm-rule-popup>
</div>
</template>

<script>
import { differenceWith, cloneDeep, isNil, isEqual, filter } from 'lodash';
import msgUtil from '@/utils/message';
import { MANAGETYPE_KEY, COMMON_KEY } from '@/constants/managetype-key';
import RscAPI from '@/api/model/rsc';
import FileApi from '@/api/common/file';
import ManagetypeKeyApi from '@/api/model/managetype-key';
import { getManagetypeKeyByObjtypeId, isMultiKeyManagetype } from '@/utils/managetype-key';
import EventAlarmRuleSettingsAPI from '@/api/settings/common/event-alarm-rule-settings';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WUpdateEventAlarmRulePopup from '../popup/UpdateEventAlarmRulePopup';

export default {
  name: 'WEventAlarmRuleTable',
  components: {
    WEventlevelCell,
    WUpdateEventAlarmRulePopup,
  },
  props: {
    selectedRule: Object,
    hasAuth: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      loading: false,
      loadingText: null,
      managetypeId: null,
      managetypeKey: null,
      managetypeIdKey: null,
      managetypeKeyList: [],
      remoteManagetypeKeyList: [],
      rsctypeId: null,
      rscId: null,
      rsctypeRscKey: null,
      loadKey: null,
      rsctypeList: [],
      rscList: [],
      title: null,
      showSearchTool: false,
      selectedRuleResourceRow: null,
      updateRow: null,
      eventAlarmRuleTableData: [],
      eventAlarmRuleTableOriginData: [],
      rsctypeDataChangeFlag: false,
      total: 0,
      eventAlarmRuleTableColumn: [
        {
          prop: 'applyFlag',
          label: '적용',
          headerAlign: 'center',
          width: 80,
          align: 'center',
          scopedSlot: 'apply-slot',
          filters: [
            {
              text: '적용',
              value: 'Y',
            },
            {
              text: '해제',
              value: 'N',
            },
          ],
        },
        {
          prop: 'rsctypeName',
          label: '자원구분명',
          headerAlign: 'center',
          width: 150,
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원명',
          headerAlign: 'center',
          width: 150,
          searchable: true,
        },
        {
          prop: 'eventJudgePriority',
          label: '판단순위',
          headerAlign: 'center',
          width: 70,
        },
        {
          prop: 'eventMessage',
          label: '이벤트 메시지',
          headerAlign: 'center',
          searchable: true,
        },
        {
          prop: 'eventlevelName',
          remoteProp: 'eventlevelId',
          label: '이벤트 등급',
          headerAlign: 'center',
          scopedSlot: 'eventlevel-slot',
          width: 90,
          searchType: 'eventlevel',
          searchable: true,
        },
        {
          prop: 'eventCondition',
          label: '이벤트 판단 조건',
          headerAlign: 'center',
          width: 150,
          searchable: true,
        },
        {
          label: '알람 방식',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'smsFlag',
              label: '문자',
              headerAlign: 'center',
              scopedSlot: 'sms-slot',
              width: 60,
              filters: [
                {
                  text: '적용',
                  value: 'Y',
                },
                {
                  text: '해제',
                  value: 'N',
                },
              ],
            },
            {
              prop: 'emailFlag',
              label: '이메일',
              headerAlign: 'center',
              scopedSlot: 'email-slot',
              width: 60,
              filters: [
                {
                  text: '적용',
                  value: 'Y',
                },
                {
                  text: '해제',
                  value: 'N',
                },
              ],
            },
          ],
        },
        {
          prop: 'alarmRepeatName',
          label: '알람 순차전송 템플릿',
          headerAlign: 'center',
          width: 160,
          searchable: true,
        },
      ],
    };
  },
  watch: {
    selectedRule: {
      handler(object) {
        if (!isNil(object)) {
          this.$refs.eventAlarmRuleTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.title = object.ruleTmplName;
          if (this.managetypeId === object.managetypeId) {
            if (this.managetypeId === 'VMS') {
              this.setManagetypeKeyListForVms(this.remoteManagetypeKeyList);
            } else if (this.managetypeId === 'DBMS') {
              this.setManagetypeKeyListForDbms(this.remoteManagetypeKeyList);
            }

            if (isMultiKeyManagetype(object.managetypeId)) {
              this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
            }
          }

          this.managetypeId = object.managetypeId;
          if (this.managetypeId === 'FMS' && this.managetypeKey === 'FS') {
            const params = {
              managetypeId: this.managetypeId,
              managetypeKey: this.managetypeKey,
              rsctypeId: object.objtypeId,
            };
            RscAPI.getRsctypeList(params).then((response) => {
              const result = response.data.data;
              if (!isNil(result)) {
                this.rsctypeList = cloneDeep(result);
                this.rsctypeId = result[0].rsctypeId;
              }
            });
          } else if (!isNil(this.managetypeIdKey) && !isNil(this.rsctypeRscKey)) {
            this.$nextTick(() => {
              this.loadKey = `${object.ruleTmplId}.${this.managetypeIdKey}.${this.rsctypeRscKey}`;
            });
          }
        }
      },
    },
    managetypeId: {
      handler(value) {
        if (!isNil(value)) {
          if (isMultiKeyManagetype(value)) {
            ManagetypeKeyApi.getDisplayedManagetypeKeyList(value)
              .then((response) => {
                if (response.data.success) {
                  this.remoteManagetypeKeyList = response.data.data;
                  if (value === 'DBMS' && !isNil(this.selectedRule.objtypeId) && this.selectedRule.objtypeId !== 'ETC') {
                    this.setManagetypeKeyListForDbms(this.remoteManagetypeKeyList);
                  } else if (value === 'VMS' && !isNil(this.selectedRule.objtypeId) && this.selectedRule.objtypeId !== 'ETC') {
                    this.setManagetypeKeyListForVms(this.remoteManagetypeKeyList);
                  } else {
                    this.managetypeKeyList = this.remoteManagetypeKeyList;
                  }
                  this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
                } else {
                  this.managetypeKeyList = MANAGETYPE_KEY[value];
                  this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
                }
              })
              .catch(() => {
                this.managetypeKeyList = MANAGETYPE_KEY[value];
                this.managetypeKey = this.managetypeKeyList[0];
              });
          } else {
            this.managetypeKey = COMMON_KEY;
          }
          // this.managetypeIdKey = `${value}.${this.managetypeKey}`;
        }
      },
    },
    managetypeKey: {
      handler(value) {
        if (!isNil(this.managetypeId)) {
          this.managetypeIdKey = `${this.managetypeId}.${value}`;
        }
      },
    },
    managetypeIdKey(key) {
      if (!isNil(key)) {
        const params = {
          managetypeId: this.managetypeId,
          managetypeKey: this.managetypeKey,
        };
        if (isEqual(this.managetypeId, 'FMS') && isEqual(this.managetypeKey, 'FS')) {
          params.rsctypeId = this.selectedRule.objtypeId;
        }
        this.$refs.eventAlarmRuleTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
        if (this.rsctypeId === 'ALL' && this.managetypeKey !== 'FS') {
          // ALL이 아닐 경우 rsctypeId의 watch속성에서 자원을 조회한다.
          this.loadRsc();
        }

        RscAPI.getRsctypeList(params).then((response) => {
          const result = response.data.data;
          if (!isNil(result)) {
            if (isEqual(this.managetypeId, 'FMS') && isEqual(this.managetypeKey, 'FS')) {
              this.rsctypeList = cloneDeep(result);
              this.rsctypeId = result[0].rsctypeId;
            } else {
              const allObject = {
                rsctypeId: 'ALL',
                rsctypeName: '전체',
              };
              result.unshift(allObject);
              this.rsctypeList = cloneDeep(result);
              this.rsctypeId = 'ALL';
            }
            this.$nextTick(() => {
              if (!isNil(this.selectedRule.ruleTmplId) && !isNil(this.rsctypeRscKey)) {
                this.loadKey = `${this.selectedRule.ruleTmplId}.${key}.${this.rsctypeRscKey}`;
              }
            });
          }
        });
      }
    },
    rsctypeId(rsctypeId) {
      if (!isNil(rsctypeId)) {
        this.$refs.eventAlarmRuleTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
        this.loadRsc();
      }
    },
    rsctypeRscKey(key) {
      if (!isNil(key)) {
        if (!isNil(this.selectedRule.ruleTmplId) && !isNil(this.managetypeIdKey)) {
          this.$refs.eventAlarmRuleTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.$nextTick(() => {
            this.rscId = key.split('.')[1];
            this.loadKey = `${this.selectedRule.ruleTmplId}.${this.managetypeIdKey}.${key}`;
          });
        }
      }
    },
    loadKey() {
      this.loadRuleData();
    },
  },
  methods: {
    isMultiKeyManagetype,
    /**
     * DBMS에 대한 관리 구분 키 목록 설정한다.
     * 만약 선택한 정책에 objtypeId가 있는 경우 공통키와 objtypeId에 해당하는 managetypeKey만 제공하도록 한다.
     * @author Ju
     * @param  {[type]} managetypeKeyList [description]
     */
    setManagetypeKeyListForDbms(managetypeKeyList) {
      const managetypeKey = getManagetypeKeyByObjtypeId(this.selectedRule.objtypeId);
      if (!isNil(managetypeKey)) {
        const keyList = [COMMON_KEY, managetypeKey];
        this.managetypeKeyList = filter(managetypeKeyList, (item) => keyList.indexOf(item.managetypeKey) >= 0);
      } else {
        this.managetypeKeyList = managetypeKeyList;
      }
    },
    /**
     * VMS에 대한 관리 구분 키 목록을 설정한다.
     * 만약 선택한 정책에 objtypeId가 있는 경우 공통키와 objtypeId에 해당하는 managetypeKey만 제공하도록 한다.
     * @author Ju
     * @param  {[type]} managetypeKeyList [description]
     */
    setManagetypeKeyListForVms(managetypeKeyList) {
      const managetypeKey = this.selectedRule.objtypeId;
      if (!isNil(managetypeKey)) {
        const keyList = [COMMON_KEY, managetypeKey];
        this.managetypeKeyList = filter(managetypeKeyList, (item) => keyList.indexOf(item.managetypeKey) >= 0);
      } else {
        this.managetypeKeyList = managetypeKeyList;
      }
    },
    loadRuleData() {
      if (this.$refs.eventAlarmRuleTabl) {
        this.loadData();
      } else {
        this.$nextTick(() => {
          this.loadData();
        });
      }
    },
    loadData() {
      const params = this.getParameter();
      this.loadingText = null;
      this.loading = true;
      EventAlarmRuleSettingsAPI.getEventAlarmRuleList(params)
        .then((response) => {
          if (response.data.success) {
            const result = response.data;
            this.total = result.total;
            this.eventAlarmRuleTableData = result.data;
            this.eventAlarmRuleTableOriginData = cloneDeep(result.data);
            this.$nextTick(() => {
              this.chackTableDataChangeFlag();
            });
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트/알람 설정', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트/알람 설정', false));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 정책 조회를 위한 파라미터를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getParameter() {
      const managetypeId = this.managetypeId;
      const managetypeKey = this.managetypeKey;
      const ruleTmplId = this.selectedRule.ruleTmplId;
      let rsctypeId = isEqual(this.rsctypeId, 'ALL') ? null : this.rsctypeId;
      if (!isEqual(this.rscId, 'ALL') && isEqual(this.managetypeId, 'VMS')) {
        rsctypeId = this.rsctypeRscKey.split('.')[0]; // 가상화 - 동일한 rscId 존재
      }
      const rscId = isEqual(this.rscId, 'ALL') ? null : this.rscId;
      const tableParams = this.$refs.eventAlarmRuleTable.getParameter();
      return {
        managetypeId,
        managetypeKey,
        ruleTmplId,
        rsctypeId,
        rscId,
        ...tableParams,
      };
    },
    dblclickRow(row) {
      this.updateRow = cloneDeep(row);
      this.$refs.updateEventAlarmRulePopup.$refs.slidingPopup.visible = true;
    },
    clickSaveButton() {
      const target = '이벤트/알람 설정';
      EventAlarmRuleSettingsAPI.updateEventAlarmRuleList(differenceWith(this.eventAlarmRuleTableData, this.eventAlarmRuleTableOriginData, isEqual)).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, target, true));
          this.loadData();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, target, false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, target, false));
        throw new Error(e);
      });
    },
    clickCancelButton() {
      this.loadData();
    },
    chackTableDataChangeFlag() {
      this.rsctypeDataChangeFlag = !isEqual(this.eventAlarmRuleTableData, this.eventAlarmRuleTableOriginData);
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    clickEventRscGetintervalButton() {
      this.$refs.eventRscGetintervalSettingpopup.$refs.slidingPopup.visible = true;
    },
    changeApplyFlag() {
      this.chackTableDataChangeFlag();
    },
    onCollectAll(value) {
      if (value) {
        // true : 전체 선택
        this.eventAlarmRuleTableData.forEach((item) => {
          item.applyFlag = 'Y';
        });
      } else {
        // false : 전체 선택 해제
        this.eventAlarmRuleTableData.forEach((item) => {
          item.applyFlag = 'N';
        });
      }
      this.chackTableDataChangeFlag();
    },
    /**
     * 자원 리스트를 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadRsc() {
      RscAPI.getRscList({
        managetypeId: this.managetypeId,
        managetypeKey: this.managetypeKey,
        rsctypeId: this.rsctypeId === 'ALL' ? null : this.rsctypeId,
      }).then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          const allObject = {
            rsctypeId: this.rsctypeId,
            rscId: 'ALL',
            rscName: '전체',
          };
          result.unshift(allObject);
          this.rscList = cloneDeep(result);
          this.rscId = 'ALL';
          this.rsctypeRscKey = `${this.rsctypeId}.${this.rscId}`;
        }
      });
    },
    /**
     * 조회한 정책 정보를 엑셀 파일로 출력한다.
     * @author Ju
     * @return {[type]} [description]
     */
    exportExcel() {
      const params = this.getParameter();
      delete params.start;
      delete params.limit;

      this.loadingText = '엑셀 출력 중..';
      this.loading = true;
      EventAlarmRuleSettingsAPI.createRuleEventAlarmExcel(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        })
        .finally(() => {
          this.loading = false;
          this.loadingText = null;
        });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventAlarmRuleSettings/components/EventAlarmRuleTable.vue